import React from "react";
import { trainings } from "../../data/SiteData";
function Pricing(props) {
  return (
    <section id="pricing" class="pricing">
      <div class="container">
        <div class="section-title">
          <span>Trainings</span>
          <h2>Trainings</h2>
          <p>
            It is time to get involved with improved Trainings , which offers
            complete courses to all of your Software Engineering, Database & WEB
            Development concerns.
          </p>
        </div>

        <div class="row">
          {trainings.map((item) => {
            return (
              <div class={item.class} data-aos="zoom-in" data-aos-delay="150">
                <div class={item.class2}>
                  <h3>{item.title}</h3>
                  <h4>
                    <sup>$</sup>
                    {item.price}
                    <span> /6 month</span>
                  </h4>
                  <ul>
                    {item.activeCourses.map((actives) => {
                      return <li>{actives}</li>;
                    })}
                    {item.inactiveCourses.map((inactives) => {
                      return <li class="na">{inactives}</li>;
                    })}
                  </ul>
                  <div class="btn-wrap">
                    <a href="./ComingSoon/index.html" class="btn-buy">
                      Enroll
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Pricing;
